var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5299 12.2501C14.5332 11.5499 14.394 10.8563 14.1206 10.2116C13.8473 9.56689 13.4456 8.98458 12.9399 8.50011H27.2799C28.2745 8.50011 29.2283 8.89519 29.9316 9.59846C30.6349 10.3017 31.0299 11.2555 31.0299 12.2501C31.0299 13.2447 30.6349 14.1985 29.9316 14.9018C29.2283 15.605 28.2745 16.0001 27.2799 16.0001H12.9399C13.4456 15.5156 13.8473 14.9333 14.1206 14.2886C14.394 13.6439 14.5332 12.9503 14.5299 12.2501Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03 12.7001C4.10865 13.696 4.47062 14.6486 5.07319 15.4455C5.67575 16.2423 6.49373 16.8501 7.43056 17.1971C8.36739 17.5441 9.38394 17.6157 10.3602 17.4036C11.3364 17.1915 12.2316 16.7045 12.94 16.0001C13.6841 15.2711 14.1945 14.3371 14.4062 13.3172C14.6179 12.2972 14.5214 11.2373 14.129 10.2724C13.7366 9.3074 13.066 8.48099 12.2025 7.89828C11.339 7.31558 10.3217 7.00293 9.28 7.0001C7.96119 6.99177 6.68783 7.48151 5.71449 8.37142C4.74115 9.26133 4.13956 10.4858 4.03 11.8001C3.99 12.0988 3.99 12.4014 4.03 12.7001Z",
    fill: "#9D43BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchLeft);
export default __webpack_public_path__ + "static/media/switch-left.9fae104bccdeb39bad436a9a34da2ab4.svg";
export { ForwardRef as ReactComponent };